"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _redux = require("redux");
var _ShareModal = _interopRequireDefault(require("./ShareModal"));
var _modals = require("../../../utils/modals");
var ConnectedShareModal = (0, _redux.compose)((0, _modals.setModalName)('ShareModal'), _exchangeReactHooks.withModal, _exchangeReactHooks.withUserContext)(_ShareModal.default);
var _default = exports.default = ConnectedShareModal;
//# sourceMappingURL=ShareModal.container.js.map